"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalChatsProvider = void 0;
const ChatsProvider_1 = require("./ChatsProvider");
const InternalChatsContext_1 = require("./InternalChatsContext");
exports.InternalChatsProvider = (0, ChatsProvider_1.createChatProvider)(InternalChatsContext_1.InternalChatsContext, {
    getChatManager: selectedOrgUser => selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getNonPatientChatManager(),
});
